import type { FaireProductEntity } from "../../entity_types/product";

export const p_87vtb36znv: FaireProductEntity = {
  token: "p_87vtb36znv",
  type: "product",
  name: "Plus Size Formal Pants Suit",
  brandToken: "b_av43xzgdd9",
  brandName: "Kos Couture",
  imageUrl:
    "https://cdn.faire.com/fastly/27b5f485f2d421248e70f8cea09c3fd0cf88746149d060078a704cb5bc1362ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/297d7c4cda9fee412d87ca8114d54202d8e67b43ba10a109bb99296ab7a65d92.jpeg",
    "https://cdn.faire.com/fastly/a4b54d97fdadcca859526288c7cead0ff38834b2d25e258fd183ef72c9fce322.jpeg",
    "https://cdn.faire.com/fastly/e6e5a3ad76b7e2a375b0f3a015105771e338087dc1b1059e131272f1a6cfc821.jpeg",
    "https://cdn.faire.com/fastly/9619f62e12564f2b0be3c7ed8e980dd8846e6f40ed34b825e34a45416d276c44.jpeg",
    "https://cdn.faire.com/fastly/b29cd46f3da6236f66b26a7e20e92d0fbde8f06e4e574d36cb6b6f348d4e5d62.jpeg",
    "https://cdn.faire.com/fastly/c57a8c91a6e44e2cc2f244a4d0316af3feaf37a26e57bb8d21296b8a67a68420.jpeg",
    "https://cdn.faire.com/fastly/017c8977d60c36de2252cd21d05041bfe84c06adcfd35a6f351371494d4a096a.jpeg",
    "https://cdn.faire.com/fastly/5e0cebbe461379711875a04e8563f17f782a32352be260f6c853c8f41186ac10.jpeg",
    "https://cdn.faire.com/fastly/27904a3ebf3c7cc6f4121d02fcc820ead5c346eb2c3e735703d7b40c29608758.jpeg",
    "https://cdn.faire.com/fastly/f51c840c2b9615c80b1a8d26b17a3277f2d90f03fc53c9957266fa50dea394ae.jpeg",
    "https://cdn.faire.com/fastly/7e5c10ef101a1bb534cd0134d68a305844536625421e942e936a13df1df1d77f.jpeg",
    "https://cdn.faire.com/fastly/dc19bcef17884c468a4d4fd5af3de3f04e5b81d6aa411b268857cea6230a1c16.jpeg",
    "https://cdn.faire.com/fastly/66a86f90391c3744aa9e563ede5ca39361bf2cce14d60318b105167d6df192ca.jpeg",
    "https://cdn.faire.com/fastly/ae055989d2a0404a12b9a10cd962e4a9d7f7e3c04b881f7fbe067af2e2093b17.jpeg",
    "https://cdn.faire.com/fastly/f62c69db4762b0a44e39c1e58d2016a14ff9b7d65f6f158dff580f19ee5f7d1a.jpeg",
    "https://cdn.faire.com/fastly/047313765deb04b796f3aeeadf825808cc1b1e741a0125478886f017ed244b20.jpeg",
    "https://cdn.faire.com/fastly/a33b38cbdb075dcf4ac0867c06d26ecff5775050a9598e469c9657c3d948684e.jpeg",
    "https://cdn.faire.com/fastly/00b78beebe5ecf79e2c0baa9c4ba66d9d5d13823afde5dc1f1f4ba0e8410e5e5.jpeg",
    "https://cdn.faire.com/fastly/e1aa5cdd5242386a056a0e5aea3c40c216cef99c438599fb8b69664443b11eee.jpeg",
    "https://cdn.faire.com/fastly/9c2df3c46b189b692b8043196153464d6ea9d938c06ea8394c9eb4b4767a48d9.jpeg",
    "https://cdn.faire.com/fastly/908e6dcc8cb07fad21e223b9e0c3e52d52009f960cba6fadd86619afc39e21fa.jpeg",
  ],
  priceDollars: 27.02,
  description:
    "Length : 51 inches\nSleeve Style : Sleeveless\nColors: Black, Royal Blue, Plum, Navy, Charcoal, Taupe, Merlot, Granite\nSizes : 14W, 16W, 18W, 20W, 22W, 24W\nFully Lined\nSoft Cup Inserts",
  tags: [],
  msrpDollars: 54.04,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:53.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
